// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Badge__badge___39lqs{color:inherit;font-weight:400;font-size:14px;line-height:20px;display:inline-block;margin:10px 8px;padding:5px 12px;border-radius:24px;background-color:#f4f3ef;cursor:pointer}.Badge__iconWrapper___2ZfKc,.Badge__inner___1XsO_{display:flex;align-items:center}.Badge__cross___2EcbZ{margin-left:6px}.Badge__isSelected___2xQJG{font-weight:500;background-color:#eae9e3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"badge": "Badge__badge___39lqs",
	"iconWrapper": "Badge__iconWrapper___2ZfKc",
	"inner": "Badge__inner___1XsO_",
	"cross": "Badge__cross___2EcbZ",
	"isSelected": "Badge__isSelected___2xQJG"
};
module.exports = ___CSS_LOADER_EXPORT___;
